var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","ma-0":"","pa-0":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","my-3":""}},[_c('v-card',{staticClass:"tmplt-title",attrs:{"flat":""}},[_vm._t("title")],2)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","text-xs-left":"","px-4":"","pb-4":"","pt-0":""}},[_c('v-card',{staticClass:"tmplt-content",attrs:{"flat":""}},[_vm._t("content")],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03c8c627","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageTemplate.vue
// module id = 183
// module chunks = 0